import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedMethodsModule } from '../../../../../../insa-custom-scripts';
import { GenericEditorEventProvider } from '../../../GenericEditorStateProvider';

@Component({
  selector: 'file-picker-standalone',
  styles: [require('../../../generic-editor.component.css').toString()],
  template: `<div class="form-group" style="position: relative;">
    <label *ngIf="label" style="display: block;">{{ label }}</label>
    <div style="display: flex; max-width: 100%; width: 11em;">
      <button
        (click)="handleFileNamePress($event)"
        [attr.title]="fileName ? 'open' : 'no file selected'"
        type="button"
        class="btn btn-default form-control"
        style="overflow: hidden; text-overflow: ellipsis; text-align: left;"
      >
        {{ fileName ? fileName : 'choose file' }}
      </button>
      <button
        type="button"
        class="btn btn-default form-control"
        style="width: auto; padding: 6px 12px;"
        (click)="handleFilePickerPress($event)"
      >
        {{ fileName ? 'X' : '. . .' }}
      </button>
    </div>
    <input
      type="file"
      class="form-control"
      id="{{ key + '-file-picker' }}"
      style="display: block; margin-right: 15px; max-width: 100%; display: none"
      (change)="onChange($event)"
    />
  </div>`,
})
export class FilePickerStandaloneComponent {
  @Input() file: {
    currName?: string;
    currContent?: string;
    newName?: string;
    newContent?: string;
  };
  @Input() key?: string; // used for <input id=*key*>
  @Input() label?: string;

  @Output() fileChange = new EventEmitter<{ name?: string; content?: string }>(
    true
  ); // on change emits selected file name and content (base64 string), larger files take some time to parse and emit

  reportIsLoaded;
  isModalVisible = false;

  constructor(private eventProvider: GenericEditorEventProvider) {}

  get fileName() {
    return this.file.newName || this.file.currName || null;
  }

  get fileFormat() {
    return this.fileName.split('.').slice(-1)[0];
  }

  get fileContent() {
    return this.file.newContent || this.file.currContent;
  }

  get inputEl(): HTMLInputElement {
    return document.getElementById(
      this.key + '-file-picker'
    ) as HTMLInputElement;
  }

  onChange(event) {
    const file = event.target.files.length ? event.target.files[0] : null;
    this.file.newName = file ? file.name : null;
    this.file.newContent = null;
    this.file.currName = null;
    this.file.currContent = null;

    if (file) {
      SharedMethodsModule.toBase64(file).subscribe(
        (fileContent: string) => {
          this.file.newContent = fileContent;
          this.fileChange.emit({
            name: this.fileName,
            content: this.fileContent,
          });
        },
        () => {
          this.file.newContent = null;
          // add an error modal with a message to a user?
        }
      );
    }
  }

  handleFilePickerPress(evt) {
    if (this.fileName) {
      // clear the selection and don't open the selector
      evt.preventDefault();
      this.inputEl.value = null;
      this.inputEl.dispatchEvent(new Event('change'));
    } else {
      // open the file selector
      this.inputEl.dispatchEvent(new MouseEvent('click'));
    }
  }

  handleFileNamePress() {
    if (this.fileName) {
      // show file
      this.openFileModal();
    } else {
      // open file selector
      this.inputEl.dispatchEvent(new MouseEvent('click'));
    }
  }

  openFileModal() {
    this.eventProvider.emit({
      name: 'OPEN_FILE_MODAL',
      value: {
        fileContent: this.fileContent,
        fileName: this.fileName,
      },
    });
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/fields/file-picker/file-picker-standalone.component.ts